import { render, staticRenderFns } from "./NetworkStatus.vue?vue&type=template&id=be08b99a&scoped=true"
import script from "./NetworkStatus.vue?vue&type=script&lang=js"
export * from "./NetworkStatus.vue?vue&type=script&lang=js"
import style0 from "./NetworkStatus.vue?vue&type=style&index=0&id=be08b99a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be08b99a",
  null
  
)

export default component.exports